/**
 * The badge for a manual evidence row: the agent's own account, not a Cofactor-verified pass.
 *
 * @module features/proofs/components/ManualBadge
 */
import React from 'react';
import { Badge } from '@chatsdet/ui';
import { sha7 } from '../evidenceKinds';
import type { ProofCriterion } from '../types';

export const ManualBadge: React.FC<{ status: ProofCriterion['status']; testId: string }> = ({ status, testId }) => (
  <Badge variant="secondary" size="sm" data-testid={testId}>
    {status.kind === 'stale' ? `Checked another way · out of date (${sha7(status.provedSha)})` : 'Checked another way'}
  </Badge>
);
